import React, { useState, useEffect } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import notifications from '../components/notifications';
import 'react-notifications/lib/notifications.css';

function Users() {
    const [usersList, setUsersList] = useState([]);
    const [editMode, setEditMode] = useState(null); // Para identificar qual usuário está sendo editado
    const [editedUser, setEditedUser] = useState({}); // Para armazenar os dados do usuário editado


    // Função para buscar usuários
    async function getUsers() {
        try {
            const resUsers = await api.get('/usuariosCadastrados');
            setUsersList(resUsers.data);
        } catch (error) {
            NotificationManager.error('Erro ao buscar usuários', 'Erro', 3000);
        }
    }

    useEffect(() => {
        getUsers();
    }, []);

    // Função para ativar o modo de edição para um usuário específico
    const handleEdit = (user) => {
        setEditMode(user.ID);
        setEditedUser({ ...user });
    };

    // Função para salvar as alterações feitas em um usuário
    const handleSave = async () => {
        try {
            await api.post('/updateUsers', editedUser); // Suponha que essa rota POST edita o usuário
            setUsersList(usersList.map(user => (user.ID === editedUser.ID ? editedUser : user)));
            setEditMode(null);
            notifications[8](); // Notificação de sucesso ao atualizar
        } catch (error) {
            notifications[9](); // Notificação de erro ao atualizar
        }
    };

    // Função para cancelar a edição
    const handleCancel = () => {
        setEditMode(null);
        setEditedUser({});
    };

    // Função para lidar com mudanças nos inputs durante a edição
    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedUser({
            ...editedUser,
            [name]: value
        });
    };

    return (
        <div className={styles.app}>
            <NotificationContainer />
            <div className={`${styles.corTitulo} ${styles.green}`}>
                <p className={styles.titulo}>Usuários Cadastrados</p>
            </div>
            <div className={styles.cadastroClienteContainer}>
                <div className={styles.usersListContainer}>
                    {usersList.length === 0 ? (
                        <p>Nenhum usuário encontrado.</p>
                    ) : (
                        <table className={styles.usersTable}>
                            <tbody>
                                {usersList.map((user) => (
                                    <div>
                                        <div >
                                            {editMode === user.ID ? (
                                                <div>
                                                    <p>login</p>
                                                    <input
                                                        style={{ width: "100%" }}
                                                        type="text"
                                                        name="login"
                                                        value={editedUser.login}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            ) : (
                                                user.login
                                            )}
                                            {editMode === user.ID ? (
                                                <div>
                                                    <p>senha</p>
                                                <input
                                                    style={{ width: "100%" }}
                                                    type="text"
                                                    name="senha"
                                                    value={editedUser.senha}
                                                    onChange={handleChange}
                                                />
                                                </div>
                                            ) : (
                                                
                                                <>
                                                {/* user.senha */}
                                                </>
                                            )}
                                        </div>
                                        <tr key={user.ID}>
                                            <td>
                                                {editMode === user.ID ? (
                                                    <input
                                                        style={{ width: "50px" }}
                                                        type="number"
                                                        name="permission"
                                                        value={editedUser.permission}
                                                        onChange={handleChange}
                                                    />
                                                ) : (
                                                    user.permission
                                                )}
                                            </td>
                                            <td>
                                                {editMode === user.ID ? (
                                                    <input
                                                        style={{ width: "50px" }}
                                                        type="number"
                                                        name="status"
                                                        value={editedUser.status}
                                                        onChange={handleChange}
                                                    />
                                                ) : (
                                                    user.status
                                                )}
                                            </td>
                                            <td>
                                                {editMode === user.ID ? (
                                                    <>
                                                        <button className={styles.saveButton} onClick={handleSave}>
                                                            Salvar
                                                        </button>
                                                        <button className={styles.cancelButton} onClick={handleCancel}>
                                                            Cancelar
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button className={styles.editButton} onClick={() => handleEdit(user)}>
                                                        Editar
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </div>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

        </div>
    );
}

export default Users;
